module.exports = __webpack_public_path__ + "assets/ecam.jpg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/ecam.jpg
// module id = 349
// module chunks = 0